import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { memo, useCallback } from 'react';
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import { getOptionAnimElements } from './config';
import { AnimElements } from 'features/account.settings/model/animation-elements';
const SwitchControl = memo(function SwitchControl(props) {
    const { element, animation_permissions, onChange } = props;
    const { title, FalseIcon, trueIcon, falseElement } = getOptionAnimElements(element);
    const onChangePermissions = useCallback((new_value) => {
        onChange({ ...animation_permissions, [element]: new_value });
    }, [animation_permissions, onChange]);
    return (_jsx(FormControlLabel, { control: _jsxs(Stack, { direction: "row", alignItems: "center", px: 2, children: [FalseIcon && (_jsx(ResponsiveIcon, { Icon: FalseIcon, color: "action", fontSize: "1.5em" })), falseElement && falseElement, _jsx(Switch, { checked: animation_permissions?.[element] ?? true, onChange: (_, checked) => onChangePermissions(checked), name: "sleep mode switcher", color: "primary" }), trueIcon] }), label: title }));
});
const default_array = {
    Аватар: [AnimElements.avatar],
    Котел: [AnimElements.flame, AnimElements.heat_request],
    Аккаунт: [AnimElements.bell_notification],
    Авария: [AnimElements.sensor_alarm, AnimElements.circuit_alarm],
    Автомобиль: [
        AnimElements.car_smoke,
        AnimElements.car_autorun,
        AnimElements.car_lock,
        AnimElements.car_siren,
    ],
};
export const ChooseAnim = memo(function ChooseAnim(props) {
    const { value: animation_permissions, onChange } = props;
    return (_jsx(_Fragment, { children: Object.entries(default_array).map(([title, array]) => {
            return (_jsxs(Box, { display: "flex", flexDirection: "column", children: [_jsx(Typography, { variant: "subtitle2", children: title }), array.map((value) => (_jsx(SwitchControl, { element: value, animation_permissions: animation_permissions, onChange: onChange }, value)))] }, title));
        }) }));
});
